<template lang="pug">
  div(:style="style")
</template>

<script>
import { theme, vuetify } from '@iez/core'
import { computed, toRefs, reactive } from '@vue/composition-api'

export default {
  props: {
    height: Number
  },

  setup (props) {
    const header = computed(() => vuetify.framework.application.top)

    const style = reactive({
      position: 'absolute',
      height: computed(() => `${props.height + header.value}px`),
      background: computed(() => theme.background.color),
      width: '100%',
      borderRadius: '0 0 24px 24px',
      marginTop: computed(
        () => header.value ? `-${header.value}px` : undefined
      )
    })

    return {
      style
    }
  }
}
</script>
